export const Analytics = () => {
  return <div>Analytics</div>;
};
